module.exports = __webpack_public_path__ + "static/media/finance_Technicians_at_Work.bca74e5b.png";